import 'css-chunksrc/client/pages/obsPage/tree/node/dropLine/styles.scss';export default {
  "dropLine": "_dropLine_1gln1_1",
  "root": "_root_1gln1_5"
};